import { render } from "./MainLayoutAdmin.vue?vue&type=template&id=4ab0af56&scoped=true"
import script from "./MainLayoutAdmin.vue?vue&type=script&lang=js"
export * from "./MainLayoutAdmin.vue?vue&type=script&lang=js"

import "./MainLayoutAdmin.vue?vue&type=style&index=0&id=4ab0af56&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab0af56"]])

export default __exports__